import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const Button = ({
	danger = false,
	visible = true,
	shown = true,
	isDelete = false,
	title,
	large = false,
	small = false,
	sm = false,
	xs = false,
	primary = false,
	info = false,
	className = '',
	label,
	leftIcon,
	rightIcon,
	icon,
	icon2,
	simpleLineIcon,
	wide = false,
	altTitle,
	success = false,
	toggle = false,
	children,
	...props
}) => (
	<button
		className={cn('btn', className, {
			'btn-default': !danger && !info && !primary,
			'btn-danger': danger,
			invisible: !visible,
			hidden: !shown,
			'btn-lg': large,
			'btn-primary': primary,
			'btn-info': info,
			'btn-labeled': Boolean(label) || Boolean(leftIcon) || Boolean(rightIcon),
			'btn-wide': wide,
			'btn-xs': small || xs,
			'btn-sm': sm,
			'btn-success': success,
			'dropdown-toggle': toggle,
		})}
		title={altTitle}
		{...props}
	>
		{simpleLineIcon && <em className={cn(`icon-${simpleLineIcon}`)} />}
		{icon && <em className={cn('fa', `fa-${icon}`)} />}
		{label && <span className="btn-label"><i className={cn('fa', `fa-${label}`)}></i></span>}
		{leftIcon && <span className="btn-label"><i className={cn('fa', `fa-${leftIcon}`)}></i></span>}
		{toggle ? (
			(toggle && title) ? (
				<React.Fragment>
					{`${title} `}<span className="caret" />
				</React.Fragment>
			) : (
				<React.Fragment>
					<span className="caret" /><span className="sr-only">default</span>
				</React.Fragment>
			)
		) : (
			title
		)}
		{(!title && !icon && !simpleLineIcon && !toggle && !children) && <em className={cn('fa', { 'fa-pencil': !isDelete, 'fa-remove': isDelete })} />}
		{icon2 && <em className={cn('fa', `fa-${icon2}`, 'ml-sm')} />}
		{rightIcon && <span className={cn('btn-label', { 'btn-label-right': Boolean(rightIcon) })}><i className={cn('fa', `fa-${rightIcon}`)}></i></span>}
		{children}
	</button>
);

Button.propTypes = {
	danger: PropTypes.bool,
	visible: PropTypes.bool,
	isDelete: PropTypes.bool,
	title: PropTypes.string,
	shown: PropTypes.bool,
	large: PropTypes.bool,
	primary: PropTypes.bool,
	info: PropTypes.bool,
	className: PropTypes.string,
	label: PropTypes.string,
	leftIcon: PropTypes.string,
	rightIcon: PropTypes.string,
	icon: PropTypes.string,
	icon2: PropTypes.string,
	simpleLineIcon: PropTypes.string,
	wide: PropTypes.bool,
	small: PropTypes.bool,
	altTitle: PropTypes.string,
	success: PropTypes.bool,
	toggle: PropTypes.bool,
	sm: PropTypes.bool,
	xs: PropTypes.bool,
	children: PropTypes.element,
};

export default Button;
